module.exports = __webpack_public_path__ + "img/CDG.3706b9cf.png";